const baseJson = () => {
    return {
        id: null,
        _id: null,
        name: null,
        nameEn: null,
        ngayBatDau: null,
        ngayKetThuc: null,
        ngayBatDauShow: null,
        ngayKetThucShow: null,
        gioBatDau: null,
        gioBatDauEn: null,
        gioKetThuc: null,
        gioKetThucEn: null,
        latitude: null,
        longitude: null,
        file: null,
        diaChi: null,
        diaChiEn: null,
        chuTri: null,
        chuTriEn: null,
        thamMuu: null,
        thamMuuEn: null,
        quyMo: null,
        quyMoEn: null,
        hinhThuc: null,
        hinhThucEn: null,
        yTuong: null,
        yTuongEn: null,
        daiBieu: null,
        daiBieuEn: null,
        phoiHop: null,
        phoiHopEn: null,
        noiDungs: []
    };
};
const toJson = (item) => {
    if (!item) return baseJson();

    return {
        id: item.id || item._id || null,
        _id: item._id || item.id || null,
        name: item.name || null,
        nameEn: item.nameEn || null,
        ngayBatDau: item.ngayBatDau || null,
        ngayKetThuc: item.ngayKetThuc || null,
        ngayBatDauShow: item.ngayBatDauShow || null,
        ngayKetThucShow: item.ngayKetThucShow || null,
        gioBatDau: item.gioBatDau || null,
        gioBatDauEn: item.gioBatDauEn || null,
        gioKetThuc: item.gioKetThuc || null,
        gioKetThucEn: item.gioKetThucEn || null,
        latitude: item.latitude || null,
        longitude: item.longitude || null,
        file: item.file ? {
            fileId: item.file.fileId || null,
            fileName: item.file.fileName || null,
            ext: item.file.ext || null,
            path: item.file.path || null
        } : null,
        diaChi: item.diaChi || null,
        diaChiEn: item.diaChiEn || null,
        chuTri: item.chuTri || null,
        chuTriEn: item.chuTriEn || null,
        thamMuu: item.thamMuu || null,
        thamMuuEn: item.thamMuuEn || null,
        quyMo: item.quyMo || null,
        quyMoEn: item.quyMoEn || null,
        hinhThuc: item.hinhThuc || null,
        hinhThucEn: item.hinhThucEn || null,
        yTuong: item.yTuong || null,
        yTuongEn: item.yTuongEn || null,
        daiBieu: item.daiBieu || null,
        daiBieuEn: item.daiBieuEn || null,
        phoiHop: item.phoiHop || null,
        phoiHopEn: item.phoiHopEn || null,
        noiDungs: Array.isArray(item.noiDungs) ? item.noiDungs.map(nd => ({
            text: nd.text || null,
            textEn: nd.textEn || null,
            icon: nd.icon || "info"
        })) : []
    };
};
const fromJson = (item) => {
    if (!item) return baseJson();
    return {
        id: item.id || item._id || null,
        _id: item._id || item.id || null,
        name: item.name || null,
        nameEn: item.nameEn || null,
        ngayBatDau: item.ngayBatDau || null,
        ngayKetThuc: item.ngayKetThuc || null,
        ngayBatDauShow: item.ngayBatDauShow || null,
        ngayKetThucShow: item.ngayKetThucShow || null,
        gioBatDau: item.gioBatDau || null,
        gioBatDauEn: item.gioBatDauEn || null,
        gioKetThuc: item.gioKetThuc || null,
        gioKetThucEn: item.gioKetThucEn || null,
        latitude: item.latitude || null,
        longitude: item.longitude || null,
        file: item.file ? {
            fileId: item.file.fileId || null,
            fileName: item.file.fileName || null,
            ext: item.file.ext || null,
            path: item.file.path || null
        } : null,
        diaChi: item.diaChi || null,
        diaChiEn: item.diaChiEn || null,
        chuTri: item.chuTri || null,
        chuTriEn: item.chuTriEn || null,
        thamMuu: item.thamMuu || null,
        thamMuuEn: item.thamMuuEn || null,
        quyMo: item.quyMo || null,
        quyMoEn: item.quyMoEn || null,
        hinhThuc: item.hinhThuc || null,
        hinhThucEn: item.hinhThucEn || null,
        yTuong: item.yTuong || null,
        yTuongEn: item.yTuongEn || null,
        daiBieu: item.daiBieu || null,
        daiBieuEn: item.daiBieuEn || null,
        phoiHop: item.phoiHop || null,
        phoiHopEn: item.phoiHopEn || null,
        noiDungs: Array.isArray(item.noiDungs) ? item.noiDungs.map(nd => ({
            text: nd.text || null,
            textEn: nd.textEn || null,
            icon: nd.icon || "info"
        })) : []
    };
};


export const chuongTrinhModel = {
    baseJson,
    fromJson,
    toJson,
};
